module.exports = __webpack_public_path__ + "img/alert-cross-icon.d77719fd.svg";